import type { DialoguePool } from '@/state/types';

export const LD_DIALOGUE: DialoguePool = {
  slowPlay: [
    "The play button has been broken since Day 1. Much like your employment contract, it is technically present but functionally useless.",
    "48 hours. If you watch it in real time, you'll have an alibi for Wednesday. I've checked the calendar.",
    "Most people try to refresh the page at this point. The page cannot be refreshed. I designed it that way. I wanted to see what you'd do.",
  ],
  tokenLoss: [
    "The play button is broken. I mentioned this. Your decision to keep pressing it is — and I want to be fair — instructive.",
    "The counter is there for a reason. I wanted you to see it. I find the number meaningful.",
    "Perseverance, misapplied. That's going in the file under 'P.' The 'P' file is the largest file.",
  ],
  solution: [
    "You've completed the training. This information is now legally in your head. I accept no responsibility for what it does there.",
    "You dragged the slider. This is not a metaphor.",
    "Training complete. You've seen the static. That's the part they don't mention in the brochure. I find it clarifying.",
  ],
  spite: [
    "You went straight for the slider. Saved 47 hours and 59 minutes. I've noted it under 'Efficiency.' It's an unprecedented column.",
  ],
};
